import { mdiFilePdf } from '@lumapps/lumx/icons';

export const WIDGET_PDF_PREVIEW_TYPE = 'pdf-preview';

export const WIDGET_PDF_PREVIEW_ICON = mdiFilePdf;

export const WIDGET_PDF_EDITION_SCOPE = 'widget-pdf-edition';

export const RELATIVE_PATH_REGEX = /^\/(?!\/)[a-zA-Z0-9-._/]+(\?[a-zA-Z0-9-._&=]+)?(#[a-zA-Z0-9-._/]+)?\/?$/;
